<template>
  <div>
    <div class="loader" v-if="isLoading"></div>
    <div class="loadertext" v-if="isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': isLoading }">
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div>
              <h4 class="mb-1">PI NON STD</h4>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label">Customer Code</label>
                  <input v-model.trim="filters.company_code" type="text" class="form-control"
                    placeholder="Search customer code" @keyup.enter="loadItems" />
                </div>
                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label">Customer Name</label>
                  <input v-model.trim="filters.company_name" type="text" class="form-control"
                    placeholder="Search customer name" @keyup.enter="loadItems" />
                </div>
                <div class="col-lg-4 col-md-12 mb-3 d-flex align-items-end">
                  <button class="btn btn-primary me-2" @click="loadItems">
                    {{ $t("search_txt") }}
                  </button>
                  <button class="btn btn-light" @click="resetFilter">
                    {{ $t("resetFilter") }}
                  </button>
                </div>
              </div>

              <vue-good-table mode="remote" :columns="columns" :rows="rows" :line-numbers="true"
                :totalRows="totalRecords" :isLoading.sync="isLoading" :pagination-options="{
                  enabled: true,
                  perPage: serverParams.per_page,
                  perPageDropdown: [],
                }" styleClass="vgt-table striped bordered" @on-page-change="onPageChange">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'customer_name'">
                    <div class="fw-semibold">{{ props.row.customer_name }}</div>
                    <div class="text-muted small">
                      {{ props.row.company_code }} / {{ props.row.sap_code }}
                    </div>
                  </span>
                  <span v-else-if="props.column.field === 'pi_create'">
                    <span class="badge bg-soft-primary text-primary">
                      {{ props.row.pi_create }}
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'pi_posted'">
                    <span class="badge bg-soft-warning text-warning">
                      {{ props.row.pi_posted }}
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'pi_printed'">
                    <span class="badge bg-soft-success text-success">
                      {{ props.row.pi_printed }}
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'actions'">
                    <button v-if="permision_role.method_read" type="button" class="btn btn-sm btn-primary"
                      @click="detailData(props.row)">
                      <i class="mdi mdi-eye-outline me-1"></i>
                      View
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";


export default {
  name: "CustomerListIndex",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      permision_role: {
        method_create: true,
        method_read: true,
        method_update: true,
        method_delete: true,
      },
      filters: {
        company_code: "",
        company_name: "",
      },
      serverParams: {
        page: 1,
        per_page: 10,
      },
      rows: [],
    };
  },
  computed: {
    columns() {
      return [
        { label: "Customer", field: "customer_name" },
        { label: "Branch", field: "branch" },
        { label: "PI Create", field: "pi_create", type: "number" },
        { label: "PI Posted", field: "pi_posted", type: "number" },
        { label: "PI Printed", field: "pi_printed", type: "number" },
        { label: "Action", field: "actions", sortable: false },
      ];
    },
    proformaInvoiceEndpoint() {
      return String(this.$settings?.endPointProformaInvoice || "").replace(/\/?$/, "/");
    },
  },
  methods: {
    resetFilter() {
      this.filters.company_code = "";
      this.filters.company_name = "";
      this.serverParams.page = 1;
      this.loadItems();
    },
    detailData(row) {
      this.$router.push({
        name: "CustomerListDetail",
        params: { id: row.company_code },
        query: {
          name: row.customer_name,
          sap_code: row.sap_code,
        },
      });
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.loadItems();
    },
    async loadItems() {
      this.isLoading = true;

      const params = {
        page: this.serverParams.page,
        limit: this.serverParams.per_page,
      };

      if (this.filters.company_code) {
        params.company_code = this.filters.company_code;
      }

      if (this.filters.company_name) {
        params.company_name = this.filters.company_name;
      }

      try {
        const response = await this.$http.get(
          `${this.proformaInvoiceEndpoint}v1/company-list/index`,
          { params }
        );
        const datas = response.data?.datas || {};

        this.rows = (datas.data || []).map((item) => ({
          company_id: item.company_id,
          company_code: item.code || "-",
          customer_name: item.name || "-",
          sap_code: item.sap_code || "-",
          branch: item.branch_list || "-",
          pi_create: item.created_nst_proforma_invoice || 0,
          pi_posted: item.posted_nst_proforma_invoice || 0,
          pi_printed: item.printed_nst_proforma_invoice || 0,
          raw: item,
        }));
        this.totalRecords = datas.total || 0;
      } catch (error) {
        this.rows = [];
        this.totalRecords = 0;
        this.handleRequestError(error, "Gagal load customer list.");
      } finally {
        this.isLoading = false;
      }
    },
    handleRequestError(error, fallbackMessage) {
      if (error?.response?.status === 500) {
        this.$router.push("/server-error");
        return;
      }

      if (error?.response?.status === 404) {
        this.$router.push("/page-not-found");
        return;
      }

      this.error(
        error?.response?.data?.errors?.message ||
        error?.response?.data?.message ||
        fallbackMessage
      );
    },
    fetchIt() {
      const userDatas = this.$getUserInfo ? this.$getUserInfo() : null;

      if (!userDatas?.sub?.permision_role) {
        this.loadItems();
        return;
      }

      let rolePermision = null;

      userDatas.sub.permision_role.forEach((permision) => {
        if (
          permision.permission.controller === "TemplatePIController" ||
          permision.permission.controller === "ProformaInvoiceController"
        ) {
          rolePermision = permision;
        }
      });

      if (rolePermision && !rolePermision.method_read) {
        this.$router.push("/authorized-error");
        return;
      }

      if (rolePermision) {
        this.permision_role = rolePermision;
      }

      this.loadItems();
    },
    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        icon: "error",
        title: message,
      });
    },
  },
  mounted() {
    this.fetchIt();
  },
};
</script>

<style scoped>
.bg-soft-primary {
  background: rgba(13, 110, 253, 0.12);
}

.bg-soft-warning {
  background: rgba(255, 193, 7, 0.18);
}

.bg-soft-success {
  background: rgba(25, 135, 84, 0.15);
}
</style>
